"use strict";

var get = require('../getValueOfKeyMatching');

function WaxSeals(params) {
  var quantity = get(params, /qty/);
  var wax_seal_style;

  if (get(params, /floral-waxseal-pers/)) {
    wax_seal_style = get(params, /floral-waxseal-pers/);
  } else {
    var wax_seal_design = get(params, /wax_seal_design/);
    var wax_seal_color = get(params, /wax_seal_color/);
    wax_seal_style = "".concat(wax_seal_color, " ").concat(wax_seal_design);
  }

  this.waxSeals.add({
    quantity: quantity,
    wax_seal_style: wax_seal_style
  });
}

module.exports = WaxSeals;